import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import Typography from 'src/components/10-atoms/typography/Typography';
import ULItem from 'src/components/10-atoms/typography/ULItem';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const EFImagesGuidelines = ({}) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { pv: theme.spacing.standard.xs },
        React.createElement(Typography, { variant: TypographyVariant.CAPTION }, "Examiners Feedback images must include:"),
        React.createElement(ULItem, { variant: TypographyVariant.CAPTION }, "Date of examination"),
        React.createElement(ULItem, { variant: TypographyVariant.CAPTION }, "Subject name (eg: Motor, General)"),
        React.createElement(ULItem, { variant: TypographyVariant.CAPTION }, "All the questions")));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default EFImagesGuidelines;
